import { ICameraVOD } from "@thingsw/pitta-modules";

export function getVideoQuality(model: string, vod: ICameraVOD) {
  if (!model) {
    return undefined;
  }

  if (model.includes("S")) {
    return undefined;
  }

  if (model.includes("DR970X") || model.includes("DR900X")) {
    if (vod.filename.includes("S") || vod.filename.includes("L")) {
      return "Low";
    }
    return "4K";
  }

  if (
    model.includes("DR750G") ||
    model.includes("DR800G") ||
    model.includes("DR890")
  ) {
    if (vod.filename.includes("S") || vod.filename.includes("L")) {
      return "Low";
    }
    return "2K";
  }

  if (
    model.includes("DR590G") ||
    model.includes("DR770X") ||
    model.includes("DR750X") ||
    model.includes("DR790X")
  ) {
    if (vod.filename.includes("S") || vod.filename.includes("L")) {
      return "Low";
    }
    return "FHD";
  }

  return undefined;
}
